module.exports = __webpack_public_path__ + "media/newstyle/images/stars_1-f8c57d76008cad6aaaa28d140351ef13.svg";